import { createSlice } from "@reduxjs/toolkit";

const saveTransmitalSlice = createSlice({
  name: "transmittals",
  initialState: [],
  reducers: {
    setTransmitalsData: (_state, action) => action.payload,
    mergeTransmitalsData: (state, action) => ({ ...state, ...action.payload }),
  },
});

const transmittalMetadataSlice = createSlice({
  name: "transmittalMetadata",
  initialState: [],
  reducers: {
    setTransmitalMetadata: (_state, action) => action.payload,
  },
});

const transmittalAccessSlice = createSlice({
  name: "transmittalAccess",
  initialState: [],
  reducers: {
    setTransmittalAccess: (_state, action) => action.payload,
  },
});

const transmittalDataForReviewsSlice = createSlice({
  name: "transmittalDataForReviews",
  initialState: null,
  reducers: {
    setTransmittalDataForReviews: (_state, action) => action.payload,
  },
});

const transmittalReferencesSlice = createSlice({
  name: "transmittalReferences",
  initialState: [],
  reducers: {
    setTransmittalReferences: (_state, action) => action.payload,
  },
});

const transmittalVersionsSlice = createSlice({
  name: "transmittalVersions",
  initialState: [],
  reducers: {
    setTransmittalVersions: (_state, action) => action.payload,
  },
});

export const { setTransmitalsData, mergeTransmitalsData } = saveTransmitalSlice.actions;
export const { setTransmitalMetadata } = transmittalMetadataSlice.actions;
export const { setTransmittalAccess } = transmittalAccessSlice.actions;
export const { setTransmittalDataForReviews } = transmittalDataForReviewsSlice.actions;
export const { setTransmittalReferences } = transmittalReferencesSlice.actions;
export const { setTransmittalVersions } = transmittalVersionsSlice.actions;

export const saveTransmital = saveTransmitalSlice.reducer;
export const saveTransmitalMetadata = transmittalMetadataSlice.reducer;
export const setTransmittalAccessReducer = transmittalAccessSlice.reducer;
export const setTransmittalDataForReviewsReducer = transmittalDataForReviewsSlice.reducer;
export const setTransmittalReferencesReducer = transmittalReferencesSlice.reducer;
export const setTransmittalVersionsReducer = transmittalVersionsSlice.reducer;
